import BaseController from '../../lib/BaseController';
import ajax from '../../services/Ajax';
import co from '../../lib/Co';

class AssetChartController extends BaseController {
  constructor(assetChart,assetNonAPTChartData,selectedasset) {
    super('asset-chart', {
      assetChart : assetChart,
      assetNonAPTChartData : assetNonAPTChartData,
      selectedAsset : selectedasset,
      filelink :  `/lookup/nonapt/getnonaptchartsforasset/`,//`${process.env.REACT_APP_API_SSL}://${process.env.REACT_APP_API_HOST_NAME}${process.env.REACT_APP_API_PORT ? ':' + process.env.REACT_APP_API_PORT : ''}/${process.env.REACT_APP_API_VDIR ? process.env.REACT_APP_API_VDIR + '/' : ''}${process.env.REACT_APP_API}/lookup/nonapt/getnonaptchartsforasset/`,
    });
  }
  downloadFile = (evt,fileLink,filename) => {
          evt.preventDefault();
          co(this, function* () {
              var results = yield ajax.get(fileLink); 
              const link = document.createElement("a");
              var extension=filename.split('.')[1];
              var attachmentType='';
              switch(extension)
              {
                  case 'xlsx':
                      attachmentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                      break;
                  case 'xls':
                      attachmentType = 'application/vnd.ms-excel';
                      break;
                  case 'pdf':
                      attachmentType = 'application/pdf';
                      break;
                  case 'zip':
                      attachmentType = 'application/x-zip-compressed';
                      break;
                  case 'png':
                      attachmentType = 'image/png';
                      break;
                  case 'jpeg':
                      attachmentType = 'image/jpeg';
                      break;
                  case 'jpg':
                      attachmentType = 'image/jpg';
                      break;
                  case 'doc':
                      attachmentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                      break;
                  case 'docx':
                      attachmentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                      break;
              }
              link.href ='data:'+attachmentType+';base64,' + results;
              link.setAttribute(
                  'download',
                  `${filename}`
              );
              document.body.appendChild(link);
              link.click();
              // Clean up and remove the link
              link.parentNode.removeChild(link);
          })
          .catch((error) => {
              console.error("Error fetching the file:", error);
            });;
      }
}

export default AssetChartController;
